import { useGetDefaultInvoices } from "@portal/queries/invoice-query";
import { SkeletonInput } from "../Skeleton/AntSkeleton";
import InvoicesSearch from "./InvoicesSearch";
import { InvoiceSearchWrapperProps } from "./type";

function InvoiceSearchWrapper(props: InvoiceSearchWrapperProps) {
  const { data, isLoading } = useGetDefaultInvoices(props.openInvoicesOnly);
  return isLoading && !data ? (
    <SkeletonInput active />
  ) : (
    <InvoicesSearch {...props} invoices={data?.list} />
  );
}

export { InvoiceSearchWrapper };
